import React from "react";
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LineChart, Line, CartesianGrid, Legend } from "recharts";
import { CHART_COLORS, importanceMeta } from "@/lib/taskUi";

export function DonutCard({ title, data, nameKey = "name", valueKey = "value", colorByImportance = false, testId }) {
  const total = data.reduce((s, d) => s + d[valueKey], 0);
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm" data-testid={testId}>
      <p className="text-sm font-semibold text-slate-700 mb-2">{title}</p>
      {total === 0 ? <p className="text-xs text-slate-400 py-10 text-center">No data yet</p> : (
        <ResponsiveContainer width="100%" height={200}>
          <PieChart>
            <Pie data={data} dataKey={valueKey} nameKey={nameKey} innerRadius={48} outerRadius={72} paddingAngle={2}>
              {data.map((d, i) => <Cell key={i} fill={colorByImportance ? importanceMeta(d.key).color : CHART_COLORS[i % CHART_COLORS.length]} />)}
            </Pie>
            <Tooltip /><Legend iconType="circle" wrapperStyle={{ fontSize: 11 }} />
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}

export function BarCard({ title, data, xKey = "name", barKey = "value", testId }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm" data-testid={testId}>
      <p className="text-sm font-semibold text-slate-700 mb-2">{title}</p>
      {data.length === 0 ? <p className="text-xs text-slate-400 py-10 text-center">No data yet</p> : (
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={data} margin={{ left: -20 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eef2f6" />
            <XAxis dataKey={xKey} tick={{ fontSize: 10 }} interval={0} angle={-15} textAnchor="end" height={50} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11 }} /><Tooltip />
            <Bar dataKey={barKey} fill="#0093D6" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}

export function TrendCard({ title, data, lines = [{ key: "completed", color: "#10B981" }], testId }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm" data-testid={testId}>
      <p className="text-sm font-semibold text-slate-700 mb-2">{title}</p>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={data} margin={{ left: -20 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#eef2f6" />
          <XAxis dataKey="date" tickFormatter={(d) => new Date(d).toLocaleDateString(undefined, { weekday: "short" })} tick={{ fontSize: 10 }} />
          <YAxis allowDecimals={false} tick={{ fontSize: 11 }} /><Tooltip /><Legend wrapperStyle={{ fontSize: 11 }} />
          {lines.map((l) => <Line key={l.key} type="monotone" dataKey={l.key} stroke={l.color} strokeWidth={2} dot={false} />)}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
